<div class="card-body table-responsive">
    <div class="row d-flex justify-content-between align-items-center">
        <div class="col-sm-12 col-md-3 col-lg-auto">
            <div class="input-group">
                <span class="input-group-text bg-primary" id="search" ngbTooltip="Filter by From date." placement="top"
                    container="body">
                    <i class="ri-task-line"></i>
                </span>
                <input type="date" class="form-control border-start-0" id="search" placeholder="From date..."
                    autocomplete="off" [(ngModel)]="fromDate">
            </div>
        </div>
        <div class="col-sm-12 col-md-3 col-lg-auto ps-1">
            <div class="input-group">
                <span class="input-group-text bg-primary" id="search" ngbTooltip="Filter by To date." placement="top"
                    container="body">
                    <i class="bx bx-calendar-week"></i>
                </span>
                <input type="date" class="form-control border-start-0" id="search" placeholder="To date..."
                    autocomplete="off" [(ngModel)]="toDate" [min]="fromDate">
            </div>
        </div>
        <div class="col-sm-12 col-md-5 col-lg-2 ps-1">
            <div class="input-group">
                <span class="input-group-text bg-primary" id="search" ngbTooltip="Filter by Status." placement="top"
                    container="body">
                    <i class="bx bx-filter"></i>
                </span>
                <select class="form-select" autocomplete="off" id="status" [(ngModel)]="status">
                    <option hidden value=null disabled selected>Choose...
                    </option>
                    <option *ngFor="let status of statuses;let i=index" [ngValue]="status">
                        {{status}}
                    </option>
                </select>
            </div>
        </div>
        <div class="col-sm-12 col-md-3 col-lg-2 me-auto ps-1">
            <div class="input-group">
                <button type="button" ngbTooltip="Fetch Records." placement="top" container="body"
                    class=" btn btn-secondary btn-sm " style="font-size: 18px;"  (click)="onStatusChange()">
                    <i class="bx bx-search-alt-2 ri-lg align-middle me-0"></i>
                </button>
            </div>
        </div>
        <div class="col-sm-12 col-md-auto">
            <button type="button" class="btn btn-secondary" (click)="upsertRegular()"
                [ngClass]="{'not-allowed':!privilege.canEdit}"
                [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): setup.regular.edit' : ''">
                <i class="bx bx-plus"></i> Apply Regular
            </button>
        </div>
    </div>
    <table class="table" id="table">
        <thead id="table-thead">
            <tr class="bg-light">
                <th scope="col" width="70">#</th>
                <th scope="col" width="200">Employee</th>
                <th scope="col" width="200">From Date</th>
                <th scope="col" width="300">To Date</th>
                <th scope="col" width="200">Duration</th>
                <th scope="col" width="200">Reason</th>
                <th scope="col" width="150" class="text-center">Status</th>
                <th scope="col" width="160" class="text-center" *ngIf="tempStatus=='APPLIED'">Actions</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let regular of regulars; let i=index">
                <td>{{i+1}}.</td>
                <td class="text-capitalize">{{ regular.status === null ? regular.appliedFor.name :regular.appliedBy.name
                    }}
                </td>
                <td>{{regular.appliedFrom | date:'MMM dd, yyyy'||'-'}}</td>
                <td>{{regular.appliedTo | date:'MMM dd, yyyy'||'-'}}</td>
                <td>{{regular.partial?'Half Day':'Full Day'}}</td>
                <td>{{regular.reason}}</td>
                <td class="text-center">
                    <span
                        class="badge rounded-pill bg-{{regular.status==='APPROVED'?'success':regular.status==='APPLIED'?'secondary':regular.status==='REVOKED'?'warning':!regular?.status?'success':'danger'}} m-1">{{regular?.status||'APPROVED'}}</span>
                </td>
                <td class="actions" *ngIf="tempStatus=='APPLIED'">
                    <i class="bx bx-edit alert-primary"
                        [ngClass]="{'no-event':regular?.isDeleteInProgress,'not-allowed':!privilege.canEdit}"
                        [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): setup.regular.edit' : 'Update Regular'"
                        (click)="upsertRegular(regular)"></i>
                    <i *ngIf="!regular?.isDeleteInProgress" class="bx bx-x alert-secondary"
                        [ngClass]="{'not-allowed':!privilege.canDelete}"
                        [ngbTooltip]="!privilege.canDelete ? 'You need permissions for this action. Required permission(s): setup.regular.delete' : 'Cancel Regular'"
                        (click)="deleteRegualar(regular,i)"></i>
                    <div *ngIf="regular?.isDeleteInProgress" role="status"
                        class="spinner-border spinner-border-sm text-danger">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </td>
            </tr>
            <tr class="no-data">
                <ng-container *ngIf="isLoading; else noDataTemplate">
                    <td colspan="8">Fetching data, please wait...</td>
                </ng-container>
                <ng-template #noDataTemplate>
                    <ng-container *ngIf="regulars && regulars.length < 1; else noSearchResults">
                        <td colspan="8">No regulars were found.</td>
                    </ng-container>
                    <ng-template #noSearchResults>
                        <td colspan="8"
                            *ngIf="searchKeyword && (regulars | search : 'name' : searchKeyword).length == 0">
                            No regulars were found for the search results.
                        </td>
                    </ng-template>
                </ng-template>
            </tr>
        </tbody>
    </table>
</div>